
<template>
  <div>
    <CRow  class="justify-content-md-center">
      <CCol sm="8">
          <CCard>
            <CCardHeader>
              {{ record.title }}
              <div class="card-header-actions">
              </div>
            </CCardHeader>
            <CCardBody>
              <CCol md="12" class="">
                <p>{{ record.description }}</p>
              </CCol>
            </CCardBody>
          </CCard>
      </CCol>
    </CRow>

    <CModal
      title="削除しますか？"
      color="danger"
      :show.sync="deleteModal"
    >
      <div class="text-center">
        <p>この業種を削除しますか？？</p>
        <p>削除してしまうと復元することはできません</p>
      </div>
      <template #footer>
        <CButton size="sm" @click="hideDeleteModal()">キャンセル</CButton>
        <CButton size="sm" color="danger" @click="deleteItem()">削除</CButton>
      </template>
    </CModal>
  </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import { mapGetters } from 'vuex';
export default {
  name: 'Home',
  components: {},
  data() {
    return {
      recordModal: false,
      deleteModal: false,
      record: {},
      options: {},
      mode: "Edit",
      industryTypes: [],
      industryLabel: {}
    }
  },
  methods: {
    formatData: function(label, d) {
        if(label == "created_at" || label == "updated_at") {
          return moment(d).format("YYYY/MM/DD HH:mm")
        } else if(label == "question_type") {
          return this.questionTypeLabel[d]
        } else if(label == "industry_id") {
          return this.industryLabel[parseInt(d)]
        } else if(label == "answer") {
          if(this.record.question_type == "radio") {
            return "選択肢"  + (parseInt(d) + 1)
          } else {
            return d
          }
        } else {
          return d
        }
    },
    hideRecordModal: function() {
      this.recordModal = false
    },
    updateItem: function() {
      axios
        .patch(process.env.VUE_APP_API_ENDPOINT + "/questions/" + this.record.id, {"question": this.record})
        .then(() => {
          this.recordModal = false
        }).catch(error => {
          console.log(error)
        })
    },
    showRecordModal: function(mode="Edit") {
      this.recordModal = true
      if(mode == "Edit") {
        this.options = this.record.content
      }
      this.mode = mode
    },
    deleteItem: function() {
      axios
        .delete(process.env.VUE_APP_API_ENDPOINT + "/questions/" + this.record.id)
        .then(() => {
          this.deleteModal = false
          this.$router.push('/questions')

        }).catch(error => {
          console.log(error)
        })
    }
  },
  mounted() {
    axios
      .get(process.env.VUE_APP_API_ENDPOINT + "/news/" + this.$route.params.id, {headers: {'Authorization': 'Bearer ' + this.idToken}})
      .then(response => {
          this.record = response.data
      }).catch(error => {
          console.log(error)
      })
  },
    computed: {
    ...mapGetters({
      idToken:'GetIdToken',
    })
  },
}
</script>
